<template>
  <div class="card-container">
    <div class="card-content" v-if="matchSourceList.join('') !== ''">
      <div class="title">
        大赛
      </div>
      <el-row :gutter="15" class="card-list">
        <el-col :span="6" v-for="(item, i) in matchSourceList" :key="item.id">
          <div
            :class="{ 'card-item': 1, active: active === i }"
            @click="clickItem(item, i)"
          >
            <div class="img-box">
              <img
                :src="item.match_img_url ? item.match_img_url : defaultCardImg"
                alt=""
              />
              <!-- @load="getImgRect" -->
            </div>
            <div class="title">
              <el-tooltip :content="item.title" placement="top-start">
                <span>{{ item.title }}</span>
              </el-tooltip>
            </div>
            <div class="content">
              <div class="left">
                <p>
                  报名时间：<span>{{ item.match_sign_info }}</span>
                </p>
                <p>
                  报名地址：
                  <el-link
                    type="primary"
                    :href="item.match_url"
                    target="_blank"
                    @click.native.stop="false"
                    >{{ item.match_url }}</el-link
                  >
                </p>
              </div>
              <div class="right">
                <el-button
                  type="primary"
                  plain
                  size="small"
                  @click="
                    $router.push({
                      name: 'CompetitionCenter-QuestionBankCenter-MatchDetail',
                      params: { id: item.id },
                      query: {
                        realExamNum: item.realExamNum,
                        trainNum: item.trainNum,
                      },
                    })
                  "
                  >查看详情</el-button
                >
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="card-content" v-if="levelMatchSourceList.join('') !== ''">
      <div class="title">
        考级
      </div>
      <el-row :gutter="15" class="card-list">
        <el-col
          :span="6"
          v-for="(item, i) in levelMatchSourceList"
          :key="item.id"
        >
          <div
            :class="{
              'card-item': 1,
              active: active === matchSourceList.length + i,
            }"
            @click="clickItem(item, matchSourceList.length + i)"
          >
            <div class="img-box">
              <img
                :src="item.match_img_url ? item.match_img_url : defaultCardImg"
                alt=""
              />
              <!-- @load="getImgRect" -->
            </div>
            <div class="title">
              <el-tooltip :content="item.title" placement="top-start">
                <span>{{ item.title }}</span>
              </el-tooltip>
            </div>
            <div class="content">
              <div class="left">
                <p>
                  报名时间：<span>{{ item.match_sign_info }}</span>
                </p>
                <p>
                  报名地址：
                  <el-link
                    type="primary"
                    :href="item.match_url"
                    target="_blank"
                    @click.native.stop="false"
                    >{{ item.match_url }}</el-link
                  >
                </p>
              </div>
              <div class="right">
                <el-button
                  type="primary"
                  plain
                  size="small"
                  @click="
                    $router.push({
                      name: 'CompetitionCenter-QuestionBankCenter-MatchDetail',
                      params: { id: item.id },
                      query: {
                        realExamNum: item.realExamNum,
                        trainNum: item.trainNum,
                      },
                    })
                  "
                  >查看详情</el-button
                >
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  name: 'subunitCard',
  props: ['sourceList'],
  data: () => ({
    active: -1,
    defaultCardImg: require('../components/img/cardImg.jpeg'),
    // initImgHeight: 0,
  }),
  // computed: {
  //   autoImgHeight() {},
  // },
  computed: {
    matchSourceList() {
      return this.sourceList.filter((item) => item.match_type === 1)
    },
    levelMatchSourceList() {
      return this.sourceList.filter((item) => item.match_type === 2)
    },
  },
  methods: {
    // getImgRect(e) {
    //   console.log(e)
    //   // vue设置图片宽高成比例
    //   const width = e.target.naturalWidth,
    //     height = e.target.naturalHeight;
    //   this.initImgHeight = height
    // },
    clickItem(item, i) {
      this.active = i
      this.$router.push({
        name: 'CompetitionCenter-QuestionBankCenter-MatchDetail',
        params: { id: item.id },
        query: {
          realExamNum: item.realExamNum,
          trainNum: item.trainNum,
        },
      })
    },
  },
}
</script>
<style scoped lang="scss">
.card-container {
  .card-content {
    .title {
      display: flex;
      align-items: center;
      width: 100%;
      height: 55px;
      font-weight: 400;
      font-size: 16px;
      color: #1678ff;
    }
    .card-list {
      // display: flex;
      // flex-wrap: wrap;

      .card-item {
        position: relative;
        // box-sizing: border-box;
        // width: 23.5%;
        margin-bottom: 20px;
        // &:not(:nth-child(4n)) {
        //     margin-right: 2%;
        // }

        border: 1px solid #e6e6e6;
        border-radius: 10px;
        background-color: #fff;
        cursor: pointer;
        transition: box-shadow 0.2s;
        &::before {
          position: absolute;
          left: -1px;
          top: -1px;
          width: 100%;
          height: 100%;
          content: '';
          display: block;
          border-radius: 10px;
          border: 1px solid transparent;
          transition: border-color 0.2s;
          pointer-events: none;
        }
        &:hover,
        &.active {
          // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
          box-shadow: 1px 0px 4px 0px #7591b8;
          &::before {
            border-color: #1678ff;
          }
          .img-box {
            img {
              transform: scale(1.05);
            }
          }
        }

        .img-box {
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
          overflow: hidden;

          img {
            display: block;
            width: 100%;
            height: 200px;
            max-width: 100%;
            max-height: 100%;
            object-fit: cover;
            transition: transform 0.3s;
          }
        }

        .title {
          padding: 10px 15px 5px;
          font-size: 18px;
          font-weight: 500;
          color: #333;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .content {
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          padding: 0 15px 10px;
          font-size: 14px;
          flex-wrap: wrap;

          .left {
            width: 70%;

            p {
              display: flex;
              line-height: 26px;
              white-space: nowrap;

              a,
              span {
                display: block;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
          }

          .right {
            padding-bottom: 5px;
          }

          @media screen and (max-width: 1600px) {
            .left {
              width: 100%;
            }

            .right {
              display: flex;
              justify-content: flex-end;
              width: 100%;
              padding-top: 5px;
            }
          }
        }
      }
    }
  }
}
</style>
